import React from "react";
import useOrderPagePref from "../../hooks/useOrderPagePref";
import "../shopmonkey/ScopeToggle.css";

// The profile menu's "Order page: New / Classic" (AdminLayout), beside Dark
// Mode: which order page this person sees (hooks/useOrderPagePref.js — saved
// to their settings, so every device follows; an open order switches at once).
export default function OrderPageSwitch() {
  const [page, choose] = useOrderPagePref();
  return (
    <div className="profile-dropdown-item sm-scope-row" title="The order page you see: the new one, or the classic one">
      <span className="profile-dropdown-item-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="4" y="3" width="16" height="18" rx="2" />
          <path d="M8 8h8M8 12h8M8 16h5" />
        </svg>
      </span>
      <span className="profile-dropdown-item-label">Order page</span>
      <span className="sm-scope-toggle" role="group" aria-label="Order page">
        {[["new", "New"], ["classic", "Classic"]].map(([value, label]) => (
          <button
            key={value}
            type="button"
            className={`sm-scope-btn${page === value ? " active" : ""}`}
            aria-pressed={page === value}
            onClick={(e) => {
              e.stopPropagation();
              choose(value);
            }}
          >
            {label}
          </button>
        ))}
      </span>
    </div>
  );
}
